import { render } from "./SliderHerroPaper.vue?vue&type=template&id=64a1e200&scoped=true"
import script from "./SliderHerroPaper.vue?vue&type=script&lang=js"
export * from "./SliderHerroPaper.vue?vue&type=script&lang=js"

import "./SliderHerroPaper.vue?vue&type=style&index=0&id=64a1e200&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a1e200"]])

export default __exports__